import { AnimationEvent } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { dropdownSlide } from '../../animations/dropdown-slide.animation';
import { DropdownService } from '../../services/dropdown.service';

/**
 * Card image placement component
 */
@Component({
  selector: 'atx-dropdown-menu',
  exportAs: `atxDropdownMenu`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  animations: [dropdownSlide],
  providers: [DropdownService],
  standalone: false,
})
export class DropdownMenuComponent {
  @Input() public isDashboardDropdown = false;
  @Input() public isPromotionDropdown = false;
  @Input() public extraClasses = [];

  public descendantMenuItemClick$ =
    this.dropdownService.descendantMenuItemClick$;
  public mouseState$ = new BehaviorSubject<boolean>(false);
  public animationStateChange$ = new EventEmitter<AnimationEvent>();

  @ViewChild(TemplateRef, { static: true })
  public templateRef!: TemplateRef<unknown>;

  constructor(public dropdownService: DropdownService) {}

  public onAnimationEvent(event: AnimationEvent): void {
    this.animationStateChange$.emit(event);
  }

  public setMouseState(visible: boolean): void {
    this.mouseState$.next(visible);
  }
}
